((clog) => {
    document.addEventListener('DOMContentLoaded', async (event) => {
        // Declaring Variables
        const setCityBtn      = document.getElementById('setCityBtn');
        const selectCities    = document.getElementById('coordinadoraCities');
        const citiesContainer = document.getElementById('citiesContainer');
  		const goCheckoutBtn   = document.getElementById('goToCheckout');
  		const checkoutBtn     = document.querySelector('button[name="checkout"]');

        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Authorization', 'Bearer jByYUpM6ZNXgfsvOBVD3s_BxDePmfaog');

        const requestOptions = { method: 'GET', headers: myHeaders }
        
        try {
            const citiesRequest = await fetch('https://pso-riteapps.com/coordinadora/web/v1/city', requestOptions)
            const citiesData = await citiesRequest.json()

            citiesContainer.style.display = 'block'

            let cityOptions = citiesData.cities.sort(function(a, b) {
                return a.name > b.name ? 1 : -1;
            })

            cityOptions = cityOptions.map( city => {
                return `<option population="${city.population}" 
                    name_depto="${city.name_depto}" 
                    value="${city.code}" 
                    price="${city.price}" 
                    city="${city.name}">${city.name.slice(0,1) + city.name.slice(1).toLowerCase()} - $${city.price}</option>`
            })

            selectCities.innerHTML = cityOptions.join('')
            clog(citiesData)
        } catch (err) {
            document.body.innerHTML('Error while loading cities due to: ' + err)
        }
        
        // Listeners
  	
  		setCityBtn.addEventListener('click', (evt) => {
            evt.preventDefault()
			let state = evt.target.getAttribute('state')
            
            if ( state === 'set' ) {
                let optionSelected = selectCities.selectedOptions[0]
                let optionJson = {
                    city: optionSelected.getAttribute('city'),
                    code: optionSelected.getAttribute('value'),
                    price: optionSelected.getAttribute('price'),
                    dpto: optionSelected.getAttribute('name_depto'),
                    population: optionSelected.getAttribute('population')
                }
    
                localStorage.setItem('coordinadoraCityData', JSON.stringify(optionJson))
                selectCities.disabled = true
                evt.target.setAttribute('state', 'change')
                evt.target.textContent = 'Cambiar'
                citiesContainer.style.right = '-22vw'
                getCartAndSetUrl( optionJson )
            }

            if ( state === 'change' ) {
                selectCities.disabled = false
                evt.target.setAttribute('state', 'set')
                evt.target.textContent = 'Seleccionar ciudad para finalizar pedido'
                goCheckoutBtn.textContent = 'Seleccione Ciudad'
                goCheckoutBtn.style.display = 'none'
                citiesContainer.style.right = '-2vw'
                goCheckoutBtn.setAttribute('href', '#')
            }
        })
        
        goCheckoutBtn.addEventListener('click', (evt) => {
          evt.preventDefault()
          if ( evt.target.getAttribute('href') === '#' ) {
            alert('Seleccione una ciudad')
          } else {
          	document.querySelector('button[name="checkout"]').click()
          }
          
        })
        
        
        // Functions
        
        async function getCartAndSetUrl( optionJson ) {
          	goCheckoutBtn.style.display = ''
          	goCheckoutBtn.textContent = 'Cargando...'
        	const getCart = await fetch('/cart.js')
            const cartData = await getCart.json()
            
            let stringItems = []
            
            cartData.items.forEach( item => {
              stringItems.push(`${item.id}:${item.quantity}`)
            })
            
            document.querySelector('button[name="checkout"]').closest('form').setAttribute('action', `/cart?checkout[shipping_address][city]=${optionJson.city}`)
            goCheckoutBtn.setAttribute('href', 'ready')
//             goCheckoutBtn.setAttribute('href', `/cart/${stringItems.join(',')}?checkout[shipping_address][city]=${optionJson.city}`)
            goCheckoutBtn.textContent = 'Finalizar Pedido'
            
        }
    })
})(console.log)